(ns web3.auth.api
  (:require [re-frame-simple.db :as db]
            [re-frame.core :as rf]
            [web3.persistence.local :as local]))

(defn local-authed? []
  (local/local-get :auth0/auth)
  )

(defn logged-in? []
  (some? (db/get :auth0/auth))
)

(defn logout! []
  (rf/dispatch [:do/auth.logout]))

(defn start-flow [mode]
  (rf/dispatch [:do/auth.start-flow {:auth-mode mode}]))

(defn get-token
  []
  (db/get-in [:auth0/auth :access-token])
  )

(defn get-profile
  []
  (db/get :auth0/profile)
  )

(defn loading? []
  (db/get :auth0/loading?)
  )

(defn loaded? []
  (db/get :auth0/loaded?)
  )

(def API
  {:local-authed? local-authed?
   :logged-in? logged-in?
   :logout! logout!
   :start-flow start-flow
   :get-token get-token
   :get-profile get-profile
   :loading? loading?
   :loaded? loaded?})